import _ from 'lodash'
import 'foundation-sites'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { CategoryData, CategoryWholeData, SubMenuData } from '../../store/manager/state'
import { Getters } from '../../store/manager/helpers'
import HelpPageLinkVue from '../form/HelpPageLink.vue'
import { Dictionary } from 'vue-router/types/router'
import ContentsNavMenu from './ContentsNavMenu.vue'

@Component({
  components: {
    'help-link': HelpPageLinkVue,
    'contents-nav-menu': ContentsNavMenu
  }
})
export default class ContentsNav extends Vue {
  name: 'ContentsNav'
  $store: Store<RootState>
  mekajikiManageUrl: string = process.env.MEKAJIKI_MANAGE_BASE_URL
  isNavMenuVisible: boolean = false
  isCategoryWholeMenu: boolean = false

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  get query(): Dictionary<string> {
    return this.$route.query
  }

  get categories(): CategoryData[] {
    return this.$store.state.manager.categoryData || []
  }

  get categoryWhole(): CategoryWholeData | undefined {
    return this.$store.state.manager.categoryWholeData || undefined
  }

  get selectedCategoryId(): number | null | undefined {
    const categoryId = this.query.category_id

    if (categoryId === 'uncategorized') {
      return null
    }
    return parseInt(categoryId, 10) || undefined
  }

  get isNoCategorySelected(): boolean {
    return _.isUndefined(this.selectedCategoryId)
  }

  get totalStorage(): number {
    return Getters.totalStorage(this.$store)
  }

  get usedStorage(): number {
    return Getters.usedStorage(this.$store)
  }

  get isLoadingCategory(): boolean {
    return this.categories.length === 0 || !this.categoryWhole
  }

  subMenuData(category: CategoryData): SubMenuData {
    const kajikiList = Getters.kajikiList(this.$store)
    const kajiki = kajikiList.find(kajiki => kajiki.kajikiId === this.siteId)
    return {
      categoryId: category.categoryId,
      categoryName: category.categoryName,
      siteItemInfo: category.siteItemInfo,
      protocol: kajiki.protocol,
      domain: kajiki.domain,
      isPublished: kajiki.isPublished,
      contentDetailPrefixPath: kajiki.contentDetailPrefixPath
    }
  }

  selectCategory(category: CategoryData): void {
    const categoryId = category.categoryId
    this.$router.push({
      name: 'contents-manage',
      params: {
        kajiki_id: this.siteId.toString()
      },
      query: {
        category_id: categoryId ? categoryId.toString() : 'uncategorized'
      }
    })

    this.trackCategory(category)
  }

  unSelectCategory(): void {
    this.$router.push({
      name: 'contents-manage',
      params: {
        kajiki_id: this.siteId.toString()
      }
    })

    this.trackCategory(Object.assign({}, <CategoryData>{
      categoryId: null,
      categoryName: '全記事一覧'
    }, this.categoryWhole))
  }

  isCategorySelected(category: CategoryData): boolean {
    const categoryId = category.categoryId
    return !this.isNoCategorySelected && (this.selectedCategoryId === categoryId)
  }

  isCategoryWholeSelected(): boolean {
    return this.selectedCategoryId === undefined
  }

  trackCategory(category: CategoryData | CategoryWholeData): void {
  }

  toggleSubMenu(): void {
    this.isNavMenuVisible = !this.isNavMenuVisible
  }

  toggleWholeMenu(): void {
    this.isNavMenuVisible = !this.isNavMenuVisible
    this.isCategoryWholeMenu = !this.isCategoryWholeMenu
  }

  hideSubMenu(): void {
    this.isNavMenuVisible = false
    this.isCategoryWholeMenu = false
  }

  menuSelected(componentName: string) {
    this.hideSubMenu()
    return this.$emit('menu-selected', componentName)
  }
}
